import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { AppConstants } from 'src/app/app.constants';
import { ClipboardService } from 'ngx-clipboard';
import { UtilsService } from 'src/app/services/utils.service';
import { LlavesService } from 'src/app/services/llaves.service';

@Component({
  selector: 'app-fragmentarllavemodal',
  templateUrl: './fragmentarllavemodal.component.html',
  styleUrls: ['./fragmentarllavemodal.component.css']
})
export class FragmentarllavemodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  usuario: any;
  listaFragmentos: any[];

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private clipboard: ClipboardService, private llavesService: LlavesService) {
    this.listaFragmentos = [];
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getFragmentarLlaveForm(this.data, this.usuario);
  }

  save() {
    if (this.listaFragmentos.length <= 0) {
      this.alert.warning('No hay fragmentos que guardar', true);
    } else {
      let request = {
        idLlavesCriptograficas: this.form.value.idLlavesCriptograficas,
        usuario: this.usuario,
        partidas: []
      };
      let index = 1;
      this.listaFragmentos.map((fragmento) => {
        request.partidas.push({
          posicion: index,
          fragmento: fragmento
        });
        index++;
      });
      this.modal.mostrarModalCargando();
      this.llavesService.guardarFragmentos(request).subscribe((data: any) => {
        this.modal.cerrarModalCargando();
        if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
          this.alert.success(data.mensaje, true);
          this.close();
        }
        else
          this.alert.error(data.mensaje, true);
      }, (error: any) => {
        console.error('Error', error);
        this.modal.cerrarModalCargando();
        this.alert.error('No se pudieron guardar los fragmentos de llave, intente de nuevo', true);
      });
    }
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  downloadKeyFile(llave, nombreArchivo) {
    let file = new Blob([llave], { type: '.txt' });
    let a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  generateFragmentos() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    let caracteres = this.form.value.llavePrivada.length;
    let tamanioFragmentos = Math.ceil(caracteres / this.form.value.fragmentos);
    let regExp = new RegExp(`.{1,${tamanioFragmentos}}`, 'g');
    this.listaFragmentos = this.form.value.llavePrivada.match(regExp);
  }

  downloadFragmentos() {
    if (this.listaFragmentos.length <= 0) {
      this.alert.warning('No hay fragmentos que descargar', true);
    } else {
      let index = 1;
      this.listaFragmentos.map((fragmento) => {
        this.downloadKeyFile(fragmento, 'LlavePrivadaFragmento' + index);
        index++;
      });
    }
  }

}
